import AppNav from '../../components/AppNav/AppNav';
import { useLocation, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ApiClient from '../../utils/ApiClient';
import { useMsal } from '@azure/msal-react';
import { tokenRequest } from '../../authConfig';

function PDFViewerPage() {
  const { formCode } = useParams();
  const { state } = useLocation();
  const routeFormData = (state || {}).formData;
  const [ formData, setFormData ] = useState(routeFormData);
  const [ fetchingFormData, setFetchingFormData ] = useState(true);
  const [ fetchingPDF, setFetchingPDF] = useState(false);
  const [ pdfObjectURL, setPdfObjectURL] = useState(null);
  const { instance } = useMsal();

  // TODO: ADAPT ERROR HANDLING
  // Use Mount Hook to fetch Form Data
  useEffect(() => {
    const getFormData = async () => {
      setFetchingFormData(true);
      try {
        const response = await ApiClient.get(`/forms/${formCode}`);
        setFormData(response.data);
        setFetchingFormData(false);
      } catch (e) {
        /*
        if (e.isAxiosError) {
          console.log(e)
          if (!e.response) {    // Backend nicht verfügbar
            navigate('/', {
              state: {
                error: 'ERROR_BACKEND_NOT_AVAILABLE',
                formCode
              },
              replace: true
            });
          } else if (e.response.data.statusCode === 404 && e.response.data.message === 'FORM_NOT_FOUND') {
            navigate('/', {
              state: {
                error: 'ERROR_FORM_NOT_FOUND',
                formCode
              },
              replace: true
            });
          } else {
            navigate('/', {
              state: {
                error: 'ERROR_FORM_DATA_FETCH_ERROR',
                formCode
              },
              replace: true
            });
          }
        } else {
          navigate('/', {
            state: {
              error: 'ERROR_UNDEFINED_REQUEST',
              formCode
            },
            replace: true
          });
        }
        */
      }
    };

    if (!routeFormData) {
      getFormData();
    } else {
      setFormData(routeFormData);
      setFetchingFormData(false);
    }
  }, [formCode, routeFormData]);

  useEffect(() => {

    if (formData) {
      const fetchPDF = async () => {
        setFetchingPDF(true);
        const query = new URLSearchParams({
          c: formCode,
          h: window.location.origin,
          p: formData.production
        });
        const accessToken = await instance.acquireTokenSilent({
          account: instance.getActiveAccount(),
          scopes: tokenRequest.scopes
        });
        const response = await ApiClient.get(`/pdfCreator/formPDF?${query}`, {
          responseType: 'blob',
          headers: {
            'Authorization': `Bearer ${accessToken.accessToken}`
          }
        });

        setPdfObjectURL(window.URL.createObjectURL(response.data))

        setFetchingPDF(false);
      }

      fetchPDF();
    }

  }, [formCode, formData, instance]);

  if (fetchingFormData) {
    return (
      <div>
        <AppNav />

        <div className="container text-center mt-4">
          <h3>
            LADE FORMULARDATEN
          </h3>
          <div className="d-flex justify-content-center mt-4">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (fetchingPDF) {
    return (
      <div>
        <AppNav />

        <div className="container text-center mt-4">
          <h3>
            LADE PDF
          </h3>
          <div className="d-flex justify-content-center mt-4">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      <AppNav />

      <div className="container">
        <h1>PDF Viewer</h1>
        <iframe src={pdfObjectURL} className="w-100 h-100" title="W3Schools Free Online Web Tutorials"></iframe>
      </div>
    </div>
  );
}

export default PDFViewerPage;
